/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { loadTranslations } from '@angular/localize';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import posthog from 'posthog-js';
import { environment } from './environments/environment';
import { loadRuntimeConfig } from '@runtime-config';

function initPosthog(): void {
  if (!environment.posthog.key || !environment.posthog.host) return;

  posthog.init(environment.posthog.key, {
    api_host: environment.posthog.host,
    person_profiles: 'identified_only',
    defaults: '2025-11-30'
  });

  // PosthogAnalyticsService читает инстанс отсюда (window.posthog).
  window.posthog = posthog;
}

async function loadLang(): Promise<void> {
  const lang = localStorage.getItem('lang') ?? 'en';
  if (lang === 'en') return;
  try {
    const res = await fetch(`/i18n/${lang}.json`);
    if (!res.ok) return;
    const data = await res.json();
    loadTranslations(data.translations ?? data);
  } catch (e) {
    console.error('Failed to load translations:', e);
  }
}

(async () => {
  await loadLang();
  await loadRuntimeConfig();
  document.title = environment.appName;
  initPosthog();
  // Тема, PrimeNG-preset и остальные провайдеры — в app.config.ts,
  // единственном месте конфигурации приложения.
  bootstrapApplication(App, appConfig).catch((err) => console.error(err));
})();
